export default "__VITE_ASSET__5ccee17a__"